import { RIGHTSHOLDER_SUB_ROUTES } from '@App/navigation/route'
import React from 'react'
import CatalogTransferLayout from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferLayout'
import CatalogTransfer from '@Scenes/RightsholderScene/CatalogTransfer'
import CatalogTransferList from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferList'
import CatalogTransferWizardLanding from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizardLanding'
import CatalogTransferView from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferView'

export const createCatalogTransferRoutes = () => ({
    path: '',
    element: <CatalogTransferLayout />,
    children: [
        {
            path: RIGHTSHOLDER_SUB_ROUTES.catalogTransfer.root,
            element: <CatalogTransferList />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.catalogTransfer.wizard, // TODO - wizard/wizard-landing text are backwards, fix me!
            element: <CatalogTransferWizardLanding />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.catalogTransfer.wizardLanding,
            element: <CatalogTransfer />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.catalogTransfer.view,
            element: <CatalogTransferView />,
        },
    ],
})
